module.exports = "/davinci/assets/232c2730cfa063874987b5ef928064af.png";